import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const ChartCard = ({ title, chartData, type = 'doughnut' }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartData || !chartRef.current) return;

    // 销毁之前的图表实例
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext('2d');

    // 根据图表类型配置
    const config = {
      type: type,
      data: {
        labels: chartData.labels || [],
        datasets: [
          {
            data: chartData.data || [],
            backgroundColor: chartData.colors || [
              '#3B82F6', // blue-500
              '#10B981', // green-500
              '#F59E0B', // yellow-500
              '#8B5CF6', // purple-500
              '#EF4444', // red-500
            ],
            borderWidth: 1,
            borderColor: '#fff',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 20,
              usePointStyle: true,
            },
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || '';
                const value = context.raw || 0;
                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                const percentage = Math.round((value / total) * 100);
                return `${label}: ${value} (${percentage}%)`;
              },
            },
          },
        },
        ...(type === 'bar' && {
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                precision: 0,
              },
            },
          },
        }),
      },
    };

    chartInstance.current = new Chart(ctx, config);

    // 清理函数
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [chartData, type]);

  if (!chartData) {
    return (
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-lg font-medium text-gray-900 mb-4">{title}</h2>
        <div className="h-64 flex items-center justify-center">
          <div className="text-center">
            <div className="spinner mx-auto"></div>
            <p className="mt-2 text-gray-500">加载图表数据中...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-lg font-medium text-gray-900 mb-4">{title}</h2>
      <div className="h-64">
        <canvas ref={chartRef}></canvas>
      </div>
      {type === 'doughnut' && chartData.data && (
        <div className="mt-4 text-center text-sm text-gray-600">
          <p>总计: {chartData.data.reduce((a, b) => a + b, 0)} 项</p>
        </div>
      )}
    </div>
  );
};

export default ChartCard;